<template>
  <section class="dd-crypto-page">
    <div class="dd-crypto-page__inner">
      <CryptoPaymentPanel />
    </div>
  </section>
</template>

<script>
import CryptoPaymentPanel from '@/new/components/effects/CryptoPaymentPanel.vue';

export default {
  name: 'WallCryptoPayment',
  components: { CryptoPaymentPanel },
  computed: {
    cryptoPaymentMode() {
      return this.$store.getters.cryptocurrencyPaymentMode;
    },
    hasCryptoPaymentInProgress() {
      return !!this.cryptoPaymentMode;
    },
    hasGenerationSessionPayment() {
      return !!this.$store.getters.effectGenerationSession?.cryptoPaymentDetails;
    },
  },
  created() {
    this.ensurePaymentContext();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.ensurePaymentContext();
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.ensurePaymentContext(next);
  },
  methods: {
    ensurePaymentContext(next) {
      if (!this.hasCryptoPaymentInProgress && this.hasGenerationSessionPayment) {
        this.$store.dispatch('returnToCryptoPaymentForGenerationSession');
      }
      if (!this.hasCryptoPaymentInProgress && !this.hasGenerationSessionPayment) {
        this.redirectBack(next);
        return;
      }
      if (next) {
        next();
      }
    },
    redirectBack(next) {
      if (next) {
        next(false);
      }
      this.$router.replace('/wall/effects');
    },
  },
};
</script>

<style scoped>
.dd-crypto-page {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}
.dd-crypto-page__inner {
  width: 100%;
  max-width: 760px;
}
@media (max-width: 480px) {
  .dd-crypto-page {
    margin-top: 0;
  }
}
</style>
